import '../styles/main.scss';
import 'vite/modulepreload-polyfill';
import $ from 'cash-dom';
import './humans/cash-dom/mixins';
import Listing from './kaan/listing';
import History from './kaan/history';
import ScrollListener from './kaan/scroll-listener';
import Search from './kaan/search';
import ImgFade from './kaan/img-fade';
import EmbedVideoLoader from './kaan/embed-video-loader';
import VideoLoader from './kaan/video-loader';
import Home from './kaan/home';
import Slideshow from './kaan/slideshow';
import Register from './kaan/register';
import Repository from './kaan/repository';
import People from './kaan/people';
import ReadMore from './kaan/read-more';
import Modal from './kaan/modal';
import PseudoFilter from './kaan/pseudo-filter';
import Newsletter from './kaan/newsletter';
import Lightbox from './kaan/lightbox';
import Sorting from './kaan/sorting';

// HUM credit
console.log("%cDesigned %cby\nKaan Architecten\nand Humans & Machines\n\nBuilt by\nHumans & Machines\n%chttps://humans-machines.com", "padding:1.2rem 0 0;display:block;font-family:sans-serif;font-size:0.8rem;line-height:1.1;", "padding:0;font-family:sans-serif;font-size:0.8rem;line-height:1.1;", "padding:0 0 1.2rem;font-family:sans-serif;font-size:0.8rem;line-height:1.1;");

// Create module instances
History.getInstance();
Listing.getInstance();
ScrollListener.getInstance();
Search.getInstance();
ImgFade.getInstance();
EmbedVideoLoader.getInstance();
VideoLoader.getInstance();

Home.getInstance();
Slideshow.getInstance();
Register.getInstance();
Repository.getInstance();
People.getInstance();
ReadMore.getInstance();
Modal.getInstance();
PseudoFilter.getInstance();
Newsletter.getInstance();
Lightbox.getInstance();
Sorting.getInstance();


// Accept hot module reloading
if (import.meta.hot) {
    // Dev related
    import('./humans/dev/vite.js').then((module) => {
        module.default();
    });

    // Enable HMR
    import.meta.hot.accept();

    // Show a message, when a spefic file was reloaded
    // @ts-ignore
    import.meta.hot.on('vite:afterUpdate', (update: UpdatePayload) => {
        // @ts-ignore
        update.updates.forEach((upd: Update) => {
            let info = {msg: 'HMR Update', color: '#000', background: '#17ef79'};
            if (/\.scss$/i.test(upd.path)) {
                info = {msg: 'SCSS Update', color: '#fff', background: '#CE679B'};
            } else if (/\.ts$/i.test(upd.path)) {
                info = {msg: 'TS Update', color: '#fff', background: '#2D79C7'};
            } else if (/\.js$/i.test(upd.path)) {
                info = {msg: 'JS Update', color: '#000', background: '#F0D81D'};
            } else if (/\.vue$/i.test(upd.path)) {
                info = {msg: 'VUE Update', color: '#32475B', background: '#3EB27F'};
            }

            // eslint-disable-next-line no-console, max-len
            console.log(`%c🎉 ${info.msg}!`, `color: ${info.color}; background: ${info.background}; font-weight: bold; display: inline-block; border-radius: 4px; padding: 3px 6px;`);
        });
    })

    // Remove previously added event listeners for body and window
    import.meta.hot.dispose((data) => {
        $('body').off();
        $(window).off();
    });
}
